export const getModelAnuncio = () => ({
    iIdAnuncio: 0,
});

export const getFormAnuncio = () => ({
    txtCatAnuncio: {
        label: ["Grupo de anuncios:"],
        value: 1,
        error: false,
        message: "Seleccione el tipo de generación de código de cupón",
    },
    chkFechaInicio: {
        label: "Fecha de Inicio",
        required: false,
        value: false,
        error: false,
    },
    txtFechaInicio: {
        label: "Fecha inicio Banner:",
        required: false,
        value: undefined,
        error: false,
    },
    chkFechaVencimiento: {
        label: "Fecha de Vencimiento",
        required: false,
        value: false,
        error: false,
    },
    txtFechaVencimiento: {
        label: "Fecha final Banner:",
        required: false,
        value: undefined,
        error: false,
    },
    txtDuracion: {
        label: "Duración del banner en segundos:",
        placeholder: "Ej. 3",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un número válido para la duración",
    },
    txtArchivo: {
        label: "Archivo:",
        required: true,
        placeholder: "Seleccione un archivo",
        value: "",
        error: false,
        message: "No se ha seleccionado ningún archivo",
    },
});

export const getAnunciosColumns = () => [
    { title: "ID", field: "iIdAnuncio", hidden: true },
    { title: "Tipo de anuncio", field: "sNombreCatAnuncio" },
    { title: "Fecha Inicio", field: "sFechaInicio" },
    { title: "Fecha de vencimiento", field: "sFechaVencimiento" },
    { title: "Duración", field: "iDuracion" },
    { title: "Ruta", field: "sRuta" },
    { title: "Fecha de creación", field: "sFechaCreacion" },
];
